<template>
	<div class="file-box">
		<input type="button" class="btn" value="选择文件" />
		<input type="file" class="file" id="upimg" @change="handleUploadSuccess" />
	</div>
</template>

<script setup>
import { checkFileUpload } from '@/utils/scm'

const emit = defineEmits(['updateData'])

const props = defineProps({
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 1024
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['p12', 'pem', 'txt', 'doc']
	}
})

const { proxy } = getCurrentInstance()

//上传成功, 数据双向绑定
const handleUploadSuccess = async (event) => {
	const file = event.target.files[0]
	var flag = await checkFileUpload(file, props.fileType, props.fileSize)
	console.log(flag, 3)
	let res = ''
	if (flag) {
		res = await readFile(file) // res 为文件中内容
	}
	emit('updateData', res)
}

// 读取文本文件内容
const readFile = async (file) => {
	const reader = new FileReader()
	const promise = new Promise((resolve, reject) => {
		reader.onload = function () {
			var result = reader.result
			var base64 = result.substring(result.indexOf(',') + 1)
			resolve(base64)
		}
		reader.onerror = function (e) {
			reader.abort()
			reject(e)
		}
	})
	reader.readAsDataURL(file, 'UTF-8') // 将文件读取为文本

	return promise
}
</script>

<style scoped lang="scss">
.file-box {
	width: 90px;
	height: 72px;
}
.btn,
.file {
	width: 90px;
	height: 72px;
	text-align: center;
	border: 1px solid #8ac1f8;
	border-radius: 5px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
}

.btn {
	z-index: 2;
	color: #fff;
	background: #a4cef9; /*  #66b1ff    409eff */
	pointer-events: none; /* 让事件传递到下一层,即: btn的层级比file高,但btn能触发file的事件 */
}
.file {
	z-index: 1;
}
</style>
